import { Component, OnInit } from '@angular/core';
import { RewardsWalletQuery, RewardsWalletService, WalletGroupItem } from '@fgb/core';
import { firstValueFrom, Observable } from 'rxjs';

@Component({
  selector: 'fgb-wallet-page',
  templateUrl: './wallet-page.component.html',
  styleUrls: ['./wallet-page.component.scss'],
})
export class WalletPageComponent implements OnInit {
  walletItems$: Observable<WalletGroupItem[]>;

  constructor(
    private rewardsWalletQuery: RewardsWalletQuery,
    private rewardsWalletService: RewardsWalletService
  ) {}

  async ngOnInit() {
    firstValueFrom(this.rewardsWalletService.fetchWalletItems());
    this.walletItems$ = this.rewardsWalletQuery.selectGroupedUnredeemedWalletItems();
  }
}
